module.exports = "/static/Images/en/Zero.png";